import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { getRouteTitle } from './route-title';

interface MetaDataProps {
  title?: string;
  description?: string;
}
export default function MetaData({ title, description }: MetaDataProps) {
  const { pathname } = useLocation();
  const resolvedTitle = title || getRouteTitle(pathname);
  const metaDescription =
    description || 'Manage and view ' + resolvedTitle + ' records in Elobooks.';

  return (
    <Helmet>
      <title>{resolvedTitle + ' | Elobooks'}</title>
      <meta name="description" content={metaDescription} />
    </Helmet>
  );
}
